import React, { useState, useEffect } from 'react';
import { Shield, X } from 'lucide-react';
import { Button } from '@/components/ui/button';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie_consent', 'all');
    localStorage.setItem('cookie_consent_date', new Date().toISOString());
    setVisible(false);
  };

  const handleEssentialOnly = () => {
    localStorage.setItem('cookie_consent', 'essential');
    localStorage.setItem('cookie_consent_date', new Date().toISOString());
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-16 md:bottom-0 left-0 right-0 z-[70] p-3 md:p-4"
      style={{ animation: 'slideUp 0.3s ease-out' }}
    >
      <div className="max-w-4xl mx-auto bg-[#1E1E1E] border border-white/10 rounded-xl p-4 md:p-5 shadow-2xl">
        <div className="flex items-start gap-3">
          <Shield className="w-5 h-5 text-[#00BFA6] mt-0.5 flex-shrink-0" />
          <div className="flex-1">
            <h3 className="text-sm font-bold text-white mb-1">Cookie-Einstellungen</h3>
            <p className="text-xs text-gray-400 mb-3 leading-relaxed">
              Wir verwenden Cookies, um die Funktionalitaet unserer App zu gewaehrleisten und dein Erlebnis zu verbessern.
              Essenzielle Cookies sind fuer den Betrieb notwendig. Weitere Informationen findest du in unserer{' '}
              <a href="/datenschutz" className="text-[#00BFA6] underline">Datenschutzerklaerung</a>.
            </p>
            <div className="flex flex-wrap gap-2">
              <Button
                data-testid="cookie-accept-all"
                onClick={handleAccept}
                className="bg-[#00BFA6] hover:bg-[#009E8A] text-black text-xs font-bold px-4 py-1.5 h-auto"
              >
                Alle akzeptieren
              </Button>
              <Button
                data-testid="cookie-essential-only"
                onClick={handleEssentialOnly}
                variant="outline"
                className="border-white/20 text-gray-300 hover:bg-white/5 text-xs px-4 py-1.5 h-auto"
              >
                Nur essenzielle
              </Button>
            </div>
          </div>
          <button
            data-testid="cookie-close"
            onClick={handleEssentialOnly}
            className="text-gray-500 hover:text-white p-1"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
      <style>{`
        @keyframes slideUp {
          from { transform: translateY(100%); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
      `}</style>
    </div>
  );
};

export default CookieBanner;
